import DeactivateModalContent from './DeactivateModalContent';
import DuplicateModalContent from './DuplicateModalContent';
import EditModalContent from './EditModalContent';
const SummaryTable = {
    DeactivateModalContent,
    DuplicateModalContent,
    EditModalContent,
};
export default SummaryTable;
